'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeClassesObject = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _constants = require('./constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var makeClassesObject = function makeClassesObject(_ref, options) {
  var _obj;

  var props = _objectWithoutProperties(_ref, []),
      code = _ref.code,
      _ref$flip = _ref.flip,
      flip = _ref$flip === undefined ? '' : _ref$flip,
      _ref$size = _ref.size,
      size = _ref$size === undefined ? '' : _ref$size,
      _ref$squared = _ref.squared,
      squared = _ref$squared === undefined ? false : _ref$squared,
      rotate = _ref.rotate;

  var obj = (_obj = {}, _defineProperty(_obj, _constants.flagIconClassesPrefixName, true), _defineProperty(_obj, _constants.flagIconClassesPrefix + 'squared', squared), _defineProperty(_obj, '' + _constants.flagIconClassesPrefix + size, size), _defineProperty(_obj, '' + _constants.flagIconClassesPrefix + code, code), _defineProperty(_obj, _constants.flagIconClassesPrefix + 'flip-' + flip, flip), _defineProperty(_obj, _constants.flagIconClassesPrefix + 'rotate-' + (rotate || ''), rotate), _defineProperty(_obj, _constants.baseThemeStyleName, options.useCssModules && options.themeStyles), _obj);

  if (props.className && options.useCssModules) {
    obj = _extends({}, obj, _defineProperty({}, props.className, true));
  }
  return obj;
};

exports.makeClassesObject = makeClassesObject;

exports.default = function (props, options) {
  return (0, _classnames2.default)(makeClassesObject(props, options));
};


//////////////////
// WEBPACK FOOTER
// ./~/react-flag-icon-css/lib/functions/classnames.js
// module id = 800
// module chunks = 0